import { Controller, useFormContext } from 'react-hook-form'
import styled from 'styled-components'

import { AnimateHeight, Input } from '@blade/ui-kit'
import { CurrencyModel } from '@root/entities/currency'
import { CurrencyNetworkIcon } from '@root/entities/currency/ui'
import { Network } from '@root/entities/network'
import { useTranslation } from '@root/shared/localization'

import { TradeSettingsAutoToggle } from '../common/trade-settings-auto-toggle'

import type { SvmValues } from '../../../common'

type Props = {}

export const TradeSettingsFormSolAutoFee: React.FC<Props> = () => {
  const { t } = useTranslation()
  const { control, watch } = useFormContext<SvmValues>()

  const solIcon = <CurrencyNetworkIcon network={Network.Solana} size={24} />

  const autoFee = watch('autoFee')

  return (
    <Root>
      <ToggleContainer>
        <FooterLabel>{t('trade_settings.priority-and-tip-fee')}</FooterLabel>
        <Controller
          control={control}
          name="autoFee"
          render={({ field }) => (
            <TradeSettingsAutoToggle
              checked={field.value}
              onChange={field.onChange}
            />
          )}
        />
      </ToggleContainer>

      <AnimateHeight>
        {autoFee ? (
          <MaxPrioritySection>
            <FieldLabel>{t('trade_settings.max-auto-priority')}</FieldLabel>
            <Controller
              control={control}
              name="maxAutoPriority"
              render={({ field }) => (
                <Input
                  numeric
                  allowLeadingZeros={false}
                  decimalScale={CurrencyModel.Sol.decimals}
                  endContent={solIcon}
                  {...field}
                />
              )}
            />
          </MaxPrioritySection>
        ) : undefined}
      </AnimateHeight>
    </Root>
  )
}

const Root = styled.div``

const FieldLabel = styled.span`
  color: var(--text-11);
  font-size: 11px;
  font-weight: 500;
  line-height: 16px;

  margin-bottom: 6px;
`

const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-bottom: 10px;
`

const FooterLabel = styled.span`
  color: var(--text-11);
  font-size: 11px;
  font-weight: 500;
  line-height: 16px;
`

const MaxPrioritySection = styled.div`
  display: grid;
  border-top: 1px solid var(--backgroundA-3);
  padding-block: 10px;
`
